<template>
  <section class="lm-card" :style="{ height: height }" @click="$emit('click')">
    <section class="lm-card_content"><img :class="['is_block', {
        'is_scale': scale
      }]" :src="src" /></section>
    <section class="lm-card_text">
      <!-- <section class="lm-card_title">{{ title }}</section>
      <section class="lm-card_intro">{{ description }}</section> -->
      <section class="lm-card_intro">{{ title }}</section>
    </section>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/styles/variable.scss';

.lm-card {
  position: relative;
  box-shadow: $shallowShadow;
  overflow: hidden;
  &:hover {
    box-shadow: $hoverShadow;
    img.is_scale {
      cursor: pointer;
      transform: scale(1.06);
    }
    .lm-card_intro {
      color: $linkColor;
    }
  }
  &_content {
    background-color: rgb(231, 231, 231);
    img {
      width: 100%;
      height: 221px;
      transition: all $transitionDuration ease;
    }
  }
  &_text {
    box-sizing: border-box;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    padding: 28px;
    height: 165.28px;
    background-color: #fff;
  }
  &_title {
    margin-bottom: 5.981px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; 
    color: $primaryColor; //#820000;
  }
  &_intro {
    height: 72px;
    line-height: 1.48rem;
    font-size: 1.125rem;
    font-weight: 700;
    cursor: pointer;
    transition: all $transitionDuration ease;
  }
}
</style>

<script>
export default {
  props: {
    src: {
      type: String,
      require: true
    },
    title: {
      type: String,
      require: true
    },
    description: {
      type: String,
      require: true
    },
    height: {
      type: String,
      default: 'auto'
    },
    scale: {
      type: Boolean,
      default: true
    }
  }
}
</script>
